import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      loginRequired: false
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue")
  },
  {
    path: "/my-sprkr",
    name: "my-sprkr",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "my-sprkr" */ "@/views/MySprkr.vue")
  },
  {
    path: "/login",
    name: "login",
    meta: {
      loginRequired: false
    },
    component: () => import(/* webpackChunkName: "login" */ "@/views/Login.vue")
  },
  {
    path: "/forget-password",
    name: "forget-password",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(
        /* webpackChunkName: "forget-password" */ "@/views/ForgetPassword.vue"
      )
  },
  {
    path: "/password-reset",
    name: "password-reset",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(
        /* webpackChunkName: "password-reset" */ "@/views/PasswordReset.vue"
      )
  },
  {
    path: "/verify-email",
    name: "verify-email",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "verify-email" */ "@/views/VerifyEmail.vue")
  },
  {
    path: "/teacher-signup",
    name: "register-teacher",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "register-teacher" */ "@/views/Register.vue")
  },
  {
    path: "/register",
    name: "register",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "register" */ "@/views/Register.vue")
  },
  {
    path: "/registered",
    name: "registered",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(
        /* webpackChunkName: "registered" */ "@/views/RegisteredThanks.vue"
      )
  },

  {
    path: "/my-boxes",
    name: "my-boxes",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "my-boxes" */ "@/views/MyBoxes.vue")
  },
  {
    path: "/my-classrooms",
    name: "my-classrooms",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "my-classrooms" */ "@/views/MyClassrooms.vue")
  },
  {
    path: "/classroom/:id",
    name: "classroom",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "classroom" */ "@/views/Classroom.vue")
  },
  {
    path: "/classroom/:classroom_id/student/:student_id/quiz-history",
    name: "student-quiz-history",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(
        /* webpackChunkName: "student-quiz-history" */ "@/views/StudentQuizHistory.vue"
      )
  },

  {
    path: "/classroom/:classroom_id/student/:student_id/practice-history",
    name: "student-practice-history",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(
        /* webpackChunkName: "student-practice-history" */ "@/views/StudentPracticeHistory.vue"
      )
  },

  {
    path: "/classroom/:classroom_id/student/:student_id/placementtest-history",
    name: "student-placementtest-history",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(
        /* webpackChunkName: "student-placementtest-history" */
        "@/views/StudentPlacementtestHistory.vue"
      )
  },

  {
    path: "/interim-box/:id",
    name: "interim-box",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "interim-box" */ "@/views/InterimBox.vue")
  },
  {
    path: "/box/:id",
    name: "box",
    meta: {
      loginRequired: false
    },
    component: () => import(/* webpackChunkName: "box" */ "@/views/Box.vue")
  },
  {
    path: "/box-quiz/:id",
    name: "box-quiz",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "box-quiz" */ "@/views/BoxQuiz.vue")
  },
  {
    path: "/box/edit/:id",
    name: "box-edit",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "box-edit" */ "@/views/BoxEdit.vue")
  },
  {
    path: "/account",
    name: "account",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "account" */ "@/views/Account.vue")
  },
  {
    path: "/account/edit-profile",
    name: "edit-profile",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "edit-profile" */ "@/views/EditProfile.vue")
  },
  {
    path: "/account/edit-password",
    name: "edit-password",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(/* webpackChunkName: "edit-password" */ "@/views/EditPassword.vue")
  },
  {
    path: "/invite-placement-test",
    name: "invite-placement-test",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(
        /* webpackChunkName: "invite-placement-test" */ "@/views/InvitePlacementTest.vue"
      )
  },
  {
    path: "/placement-tests",
    name: "placement-tests",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(
        /* webpackChunkName: "placement-tests" */ "@/views/PlacementTests.vue"
      )
  },
  {
    path: "/placement-test/:test_id/review/:result_id",
    name: "review-placement-test-result",
    meta: {
      loginRequired: true
    },
    component: () =>
      import(
        /* webpackChunkName: "review-placement-test-result" */ "@/views/ReviewPlacementTestResult.vue"
      )
  },
  {
    path: "*",
    name: "fourOfour",
    meta: {
      loginRequired: false
    },
    component: () =>
      import(/* webpackChunkName: "404" */ "@/views/FourOFour.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const { meta, name } = to;
  const { account } = store.state;
  // SET_BACK_ROUTE - the page we set to go back to
  // SET_LAST_ROUTE - the browsers prev page for fallback
  store.commit("setting/SET_BACK_ROUTE", null);
  store.commit("setting/SET_LAST_ROUTE", from);
  if (meta.loginRequired && !account?.loggedIn) {
    next({ name: "login", query: { nextUrl: name } });
  } else {
    next();
  }
});

export default router;
